import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { unexpectedError, filter, intialPaginationState, showingPageTotalRange, PictureCell } from '../../common_functions';

const StampList = props => {
  const [stamps, setStamps] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Artist / Creator',
      dataIndex: 'artist',
      key: 'artist',
      sorter: true,
      ...filter('artist'),
      render: (text, record) => (
        <span style={{ textTransform: 'capitalize' }}>{!!record.artist && `${record.artist.First_Name} ${record.artist.last_name}`}</span>
      ),
    },
    {
      title: 'Stamp Name',
      dataIndex: 'stamp_name',
      key: 'stamp_name',
      sorter: true,
      ...filter('stamp_name'),
    },
    {
      title: 'Source Name',
      dataIndex: 'source_name',
      key: 'source_name',
      sorter: true,
      ...filter('source_name'),
    },
    {
      title: 'Source Reference',
      dataIndex: 'source_reference',
      key: 'source_reference',
      sorter: true,
      ...filter('source_reference'),
    },
    {
      title: 'Picture',
      dataIndex: 'picture',
      key: 'picture',
      render: (text, record) => (!!text ? <PictureCell dataIndexValue={text} getFile={props.getFile} width={50} /> : '-'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/stamps/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_stamps?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_stamps?.edit ? <FormOutlined /> : <EyeOutlined />}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(props, record.id, 'stamps', 'Stamp?', stamps, setStamps, props?.tabs_permissions?.settings_stamps?.delete)}
          </div>
        </span>
      ),
    },
  ];
  //Get collection data
  useEffect(() => {
    (async () => {
    await getLocationsData(pagination);
  })();
  }, []);

  const getLocationsData = async (pagination, filters = {}, sorter = '') => {
    setLoading(true);
    try {
      const response = await props.getItems('stamps', {
        fields: ['*,artist.First_Name,artist.last_name'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setStamps(response.data);
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        if (val) {
          if (key == 'artist') {
            filtersitems['_or'] = [{ artist: { last_name: { _icontains: val[0] } } }, { artist: { First_Name: { _icontains: val[0] } } }];
          } else {
            filtersitems[key] = { _icontains: val[0] };
            filtersitems[key] = key == 'id' ? { _eq: val[0] } : { _icontains: val[0] };
          }
        }
      }
    }
    await getLocationsData(pagination, filtersitems, sorter);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/stamps" }, { title: "Stamps" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Stamps
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(props.roleType, props.tabs_permissions.settings_stamps, `/settings/stamps/new`, 'Create Stamps')}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={stamps}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default StampList;
